import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import { makeStyles, useTheme } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px',
    marginRight: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const ClientStructure = ({
  type,
  onChange,
  onStructureAdded,
  onStructureRemove,
  value,
  error,
  children,
  title,
  client_structure_data,
  structure_types,
  disabled,
  ...props
}) => {


  const handleChange = event => {
    onChange(event, 'client_structure_data')
  }

  const handleNewStructure = event => {
  	onStructureAdded()
  }

  const handleRemoveStructure = (event, idx) =>{
  	onStructureRemove(idx)
  }

  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      {client_structure_data.map((val, idx)=>
      	<React.Fragment>

  	      <FormControl className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Tipo de estructura</Typography>
		    <Select native name='structure_type_id'
		        inputProps={{
		          name:"client_structure_data."+idx+".structure_type_id",
		          className:"client_structure_data."+idx+".structure_type_id"
		        }}
		        style={{minWidth: 150, fontSize: '0.75rem'}}
		        onChange={handleChange}
		        disabled={disabled}
		        value={client_structure_data[idx].structure_type_id}
		        input={<Input id="grouped-native-select" name={"client_structure_data."+idx+".structure_type_id"}/>}>
		        <option value="" label="Seleccione"/>
		        {structure_types.map(( structure_type) => <option id={structure_type.id} value={structure_type.id}>{structure_type.name}
		      </option>)}
		    </Select>
		  </FormControl>      	

	      <TextField
	        id={"client_structure_data."+idx+".code"}
	        name={"client_structure_data."+idx+".code"}
	        label="Nombre estructura"
	        type="text"
	        placeholder="Ingrese el nombre"
	        onChange={handleChange}
	        value={client_structure_data[idx].code}
	        disabled={disabled}
	        margin="normal"
	        className="mr-2 "
	        InputLabelProps={{
	          shrink: true
	        }}
	        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
	      />
	      <TextField
	        id={"client_structure_data."+idx+".name"}
	        name={"client_structure_data."+idx+".name"}
	        label="Codigo estructura"
	        type="text"
	        placeholder="Ingrese el código"
	        onChange={handleChange}
	        disabled={disabled}
	        value={client_structure_data[idx].name}
	        margin="normal"
	        className="mr-2 "
	        InputLabelProps={{
	          shrink: true
	        }}
	        inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
	      />
	      {(Object.keys(client_structure_data).length > 1)?
  	      <FormControl className={classes.formControl} inputProps={{shrink: true}}><Typography className={classes.typography}>Estructura superior</Typography>
			    <Select native name='parent_structure_id'
			        inputProps={{
			          name:"client_structure_data."+idx+".parent_structure_id",
			          className:"client_structure_data."+idx+".parent_structure_id"
			        }}
			        style={{minWidth: 150, fontSize: '0.75rem'}}
			        onChange={handleChange}
			        disabled={disabled}
			        value={client_structure_data[idx].parent_structure_id}
			        input={<Input id="grouped-native-select" name={"client_structure_data."+idx+".parent_structure_id"}/>}>
			        <option value="" label="Seleccione" />
			        {client_structure_data.map((client_structure, key) => {
				        	if (client_structure.code !== client_structure_data[idx].code && client_structure.name !== client_structure_data[idx].name){
					        	return <option id={key} value={key}>{client_structure.code} - {client_structure.name}</option>	
					        }
			        })}
			    </Select>
			  </FormControl>      	
			:
			''
	      }
		<IconButton size="small" disabled={disabled} onClick={handleNewStructure} >
			<AddIcon  />
		</IconButton>
		<IconButton size="small" onClick={(e) => handleRemoveStructure(e,idx)}
			disabled={disabled || ( Object.keys(client_structure_data).length === 1) ? true : false} >
			<RemoveIcon />
		</IconButton>
      	<div className="row"></div>
      	</React.Fragment>
		)}
	</React.Fragment>
	)
}

ClientStructure.defaultProps = {
  type: "text",
  className: "",
}

ClientStructure.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default ClientStructure;	